module.exports = __webpack_public_path__ + "static/media/academy.0d48747d.png";